import { FC } from "react";
import { Button, ButtonProps, Grid } from "antd";
import { createPortal } from "react-dom";
import classNames from "classnames";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useStepButtonsPortal } from "../../context";

const baseClassNames = {
  root: "py-4! flex! items-center! h-full!",
  icon: "flex! items-center!",
};

const baseButtonProps: ButtonProps = {
  type: "primary",
  className: "font-semibold! rounded-sm! border-none! min-w-40! w-full!",
  classNames: baseClassNames,
};

type StepButtonsProps = {
  onNext?: () => void;
  nextLabel?: React.ReactNode;
  isNextLoading?: boolean;
  isNextDisabled?: boolean;
  isPrevDisabled?: boolean;
  hideNext?: boolean;
};

const StepButtons: FC<StepButtonsProps> = ({
  onNext,
  nextLabel,
  isNextLoading,
  isNextDisabled,
  hideNext,
}) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const { portalContainer } = useStepButtonsPortal();

  const buttons = (
    <div className="flex flex-col-reverse md:flex-row md:justify-end w-full items-center gap-2 py-4">
      {!hideNext && nextLabel && (
        <Button
          {...baseButtonProps}
          disabled={isNextDisabled}
          loading={isNextLoading}
          iconPlacement="end"
          onClick={onNext}
          className={classNames(
            baseButtonProps.className,
            isNextDisabled ? "bg-background-disabled! text-font-disabled!" : "bg-background-primary! text-font-inverted!",
          )}
          classNames={{ ...baseClassNames, root: `${baseClassNames.root} px-10!` }}
        >
          {nextLabel}
        </Button>
      )}
    </div>
  );

  if (!isLargeScreen && portalContainer) {
    return createPortal(buttons, portalContainer);
  }

  return buttons;
};

export default StepButtons;
